// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"71d2491c","513":"2c1c4c19","703":"c2b9f0be","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};